import { createEvent, createStore } from "effector";

export const log = createEvent<string>();
export const $text = createStore("Console:").on(log, (state, payload) => `${state}\n${payload}`);
